import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import type { DownloadReportsInteractor } from '../../../features/reports/domain/interactors/download-reports.interactor'

interface ReportsContextType {
  downloadReports: DownloadReportsInteractor
}

const CorisReportsContext = createContext<ReportsContextType>()

export const CorisReportsProvider = (props: { children: JSX.Element }): JSX.Element => {
  const reportsComponent = MainModule.getReportsComponent()

  const defaultContextValue: ReportsContextType = {
    downloadReports: reportsComponent.provideDownloadReports()
  }

  return <CorisReportsContext.Provider value={defaultContextValue}>{props.children}</CorisReportsContext.Provider>
}

export const useCorisReports = (): ReportsContextType => {
  const context = useContext(CorisReportsContext)
  if (!context) {
    throw new Error('useCorisReports must be used inside a CorisReportsProvider')
  }
  return context
}
